
/* @flow */
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import CustomerService from 'frilans-finans/customers/customer-service';
import Spinner from 'components/spinner/spinner';
import GeneralError from 'components/general-error/general-error';
import Modal from 'react-modal';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import EditCustomer from './edit-customer';
import _ from 'lodash';
import InvoiceValidator from 'redux/modules/invoice/invoice-validator';
import Pointer from '../../../components/svg/pointer';

export class PickCustomer extends React.Component {

  static propTypes = {
    customerId: PropTypes.number,
    customerEntity: PropTypes.object,
    submitted: PropTypes.bool.isRequired,
    setCustomerId: PropTypes.func.isRequired,
    setCustomerEntity: PropTypes.func.isRequired,
    setSendToEmail: PropTypes.func.isRequired,
    setSendToEmailSecondary: PropTypes.func.isRequired,
    setMessageType: PropTypes.func.isRequired,
    setEinvoiceAddress: PropTypes.func.isRequired,
    setPoNumber: PropTypes.func.isRequired,
    setCompanyPhone: PropTypes.func.isRequired,
    translationPrefix: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      fetching: false,
      customers: [],
      contentFetched: false,
      page: 1,
      pageRange: 5,
      meta: {
        totalPages: 1
      },
      chosenCustomer: null,
      modalIsOpen: false,
      editCustomer: true,
      pendingRequestFetchCustomers: null,
      pendingRequestFetchCustomersById: null,
      customerIdFetchOnLoad: null,
      selectedOption: '',
      searchValue: ''
    };

    this.fetchCustomers = this.fetchCustomers.bind(this);
    this.setChosenCustomer = this.setChosenCustomer.bind(this);
    this.editCustomer = this.editCustomer.bind(this);
    this.createCustomer = this.createCustomer.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.updateCustomer = this.updateCustomer.bind(this);
    this.showMore = this.showMore.bind(this);
    this.renderCustomerList = this.renderCustomerList.bind(this);
    this.saveCustomerEntityToRedux = this.saveCustomerEntityToRedux.bind(this);
    this.setChosenCustomerById = this.setChosenCustomerById.bind(this);
    this.searchCustomer = this.searchCustomer.bind(this);
  }

  componentWillReceiveProps (props) {
    if (props.customerId > 0) {
      if (this.state.customers.length === 0) {
        this.setState({
          customerIdFetchOnLoad: props.customerId
        });
      } else if (!this.state.chosenCustomer) {
        this.setChosenCustomerById(props.customerId);
      }
    }
  }

  saveCustomerEntityToRedux () {
    this.props.setCustomerEntity(this.state.chosenCustomer);
  }

  componentDidMount () {
    this.fetchCustomers();
  }

  componentWillUnmount () {
    if (this.state.pendingRequestFetchCustomers && this.state.pendingRequestFetchCustomers.cancel) {
      this.state.pendingRequestFetchCustomers.cancel();
    }

    if (this.state.pendingRequestFetchCustomersById && this.state.pendingRequestFetchCustomersById.cancel) {
      this.state.pendingRequestFetchCustomersById.cancel();
    }
  }

  fetchCustomers () {
    const userId = +this.props.user.id;
    let pendingRequestFetchCustomers = CustomerService.get(userId, this.state.page, 200, this.state.searchValue);
    pendingRequestFetchCustomers.promise
      .then((response) => this.handleResponse(response));
    this.setState({
      pendingRequestFetchCustomers: pendingRequestFetchCustomers
    });
  }

  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
    this.setChosenCustomer(selectedOption);
  }

  handleResponse (apiResult) {
    this.setState({
      fetching: false,
      customers: this.state.page === 1
        ? apiResult.collection
        : this.state.customers.concat(apiResult.collection),
      contentFetched: true,
      total: apiResult.meta.total,
      totalPages: Math.ceil(apiResult.meta.total / apiResult.meta.currentPage),
      meta: apiResult.meta
    }, () => {
      if (this.state.customerIdFetchOnLoad && !this.state.chosenCustomer) {
        this.setChosenCustomerById(this.state.customerIdFetchOnLoad);
      }
    });
  }

  setChosenCustomerById (id) {
    let chosenCustomer = this.state.customers.find(function (customer) {
      return parseInt(id) === parseInt(customer.id);
    });

    if (chosenCustomer) {
      this.setState({
        chosenCustomer: chosenCustomer
      });
      this.props.setCustomerEntity(chosenCustomer);

      this.props.setSendToEmail(chosenCustomer.sendToEmail);
      this.props.setSendToEmailSecondary(chosenCustomer.sendToEmailSecondary);
    } else {
      let pendingRequest = CustomerService.getById(id);
      pendingRequest.promise
        .then((response) => {
          this.setState({
            chosenCustomer: response,
            customerIdFetchOnLoad: null
          },
            this.saveCustomerEntityToRedux
          );
        });

      this.setState({
        pendingRequestFetchCustomersById: pendingRequest
      });
    }
  }

  setChosenCustomer (e) {
    var chosenCustomer = this.state.customers.find(function (customer) {
      return e.id === customer.id;
    });

    this.selectCustomer(chosenCustomer);
  }

  selectCustomer (customer) {
    this.setState({
      chosenCustomer: customer
    });

    this.props.setCustomerId(parseInt(customer.id));
    this.props.setCustomerEntity(customer);

    this.props.setSendToEmail(customer.sendToEmail);
    this.props.setSendToEmailSecondary(customer.sendToEmailSecondary);

    if (customer.phone) {
      this.props.setCompanyPhone(customer.phone);
    }

    this.props.setMessageType(customer.messageType);

    this.props.setEinvoiceAddress(customer.eInvoiceAddress);
    this.props.setPoNumber(customer.poNumber);
  }

  updateCustomer (updatedCustomer) {
    let customers = this.state.customers;

    if (this.state.editCustomer) {
      let customerIndex = _.findIndex(customers, function (o) { return o.id === updatedCustomer.id; });
      customers[customerIndex] = updatedCustomer;
    } else {
      customers.push(updatedCustomer);
    }

    this.setState({
      customers: customers
    }, () => {
      this.selectCustomer(updatedCustomer);
      this.onCloseModal();
    });
  }

  editCustomer (e) {
    e.preventDefault();

    this.setState({
      modalIsOpen: true,
      editCustomer: true
    });
  }

  createCustomer (e) {
    e.preventDefault();

    this.setState({
      modalIsOpen: true,
      editCustomer: false
    });
  }

  onCloseModal () {
    this.setState({
      modalIsOpen: false
    });
  }

  searchCustomer (searchValue) {
    this.setState({
      page: 1,
      searchValue: searchValue
    }, this.fetchCustomers);
  }

  showMore () {
    this.setState({
      page: this.state.page + 1
    }, this.fetchCustomers);
  }

  renderError () {
    if (this.props.submitted && !InvoiceValidator.validateCustomer(this.props.customerId)) {
      return (
        <div className="col-sm-12">
          <p className="error"><Translate content='INVOICE_ERROR_CUSTOMER' /></p>
        </div>
      );
    }
  }

  renderModal () {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen={this.state.modalIsOpen}
        shouldCloseOnOverlayClick={false}
        onRequestClose={this.onCloseModal}>
        <div className='modal-content'>
          <button className='close' onClick={this.onCloseModal}></button>
          <EditCustomer
            edit={this.state.editCustomer}
            customer={this.state.chosenCustomer}
            callback={this.updateCustomer}
            onCloseModal={this.onCloseModal} />
        </div>
      </Modal>
    );
  }

  renderLoader () {
    if (this.state.fetching) {
      return (
        <div className='loader-wrapper'>
          <Spinner />
        </div>
      );
    }
  }

  renderCustomer () {
    let customer = this.state.chosenCustomer;

    if (customer && customer.id) {
      return (
        <div>
          <p className='dark-bold'>{customer.name}</p>
          <p>{customer.vatNr}</p>
          <p>{customer.address.co}</p>
          <p>{customer.address.street}</p>
          <p>{customer.address.zip} {customer.address.city}</p>
          <p><Translate content='REF' />: {customer.contact}</p>
          <p>{customer.sendToEmail}</p>
          <a href='#' className='edit-customer' onClick={this.editCustomer}><Translate content='EDIT_INFO' /></a>
        </div>
      );
    }

    return false;
  }

  renderCustomerList () {
    /*eslint-disable */
    let options = this.state.customers.map(function (customer) {
      return { value: customer.id, label: customer.name };
    });
    /* eslint-enable */

    const debounceCustomer = _.debounce(this.searchCustomer, 500);

    return (
      <div>

        {!this.state.fetching &&
          <Select
            name="form-field-name"
            clearable={false}
            value={this.state.chosenCustomer}
            onChange={this.handleChange}
            searchable={this.state.searchable}
            labelKey='name'
            valueKey='id'
            noResultsText={<Translate content='CUSTOMER_SELECT_NOTFOUND' />}
            placeholder={<Translate content='CUSTOMER_SELECT_LABEL' />}
            options={this.state.customers}
            onMenuScrollToBottom={this.showMore}
            scrollMenuIntoView={false}
            onInputChange={debounceCustomer}
          />
        }

      </div>
    );
  }

  renderForm () {
    return (
      <div>
        <div className='col-sm-6 customer-box-wrapper'>
          <div className='customer-box first-box'>
            <p className='dark-bold'><Translate content='CHOOSE_CUSTOMER' /></p>
            {this.renderCustomerList()}
          </div>
          {this.renderLoader()}
          <a href='#' className='pointer-link-large' onClick={this.createCustomer}>
            <Translate content='CUSTOMER_ADD' />
            <Pointer color="primary" />
          </a>
        </div>
        <div className='col-sm-6'>
          <div className='customer-box second-box'>{this.renderCustomer()}</div>
        </div>
        {this.renderModal()}
      </div>
    );
  }

  getContent () {
    if (this.state.fetchError) {
      return (<div className='row'><GeneralError /></div>);
    }

    return this.renderForm();
  }

  render () {
    let content = this.getContent();

    return (
      <div className='pick-customer section-padding'>
        <div className='col-sm-12'>
          <h3 className='form-header'>
            <span>1</span>
            <Translate content='CUSTOMER' />
          </h3>
          <p><Translate content={this.props.translationPrefix + 'CUSTOMER_TEXT'} /></p>
        </div>
        {content}
        {this.renderError()}
      </div>
    );
  }
}

export default PickCustomer;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/customer/pick-customer.js
 **/